import { FC, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Divider, IconButton, Menu, MenuItem } from '@material-ui/core'
import { AccountCircle, ExitToApp, Person } from '@material-ui/icons'
import { RootState } from '../../Store'
import { userInfoStyle } from './UserInfo.style'
import { FormattedMessage } from 'react-intl'
import { authActions } from 'src/actions/AuthAction'

export interface UserInfoProps {} // eslint-disable-line @typescript-eslint/no-empty-interface

const defaultProps: UserInfoProps = {
}

export const UserInfo: FC<UserInfoProps> = (props: UserInfoProps) => {
  const classes = userInfoStyle()
  const dispatch = useDispatch()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const username = useSelector((state: RootState): string => state.authState.username)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = (): void => {
    setAnchorEl(null)
  }
  const handleLogout = (): void => {
    setAnchorEl(null)
    dispatch(authActions.logout())
  }
  return (
    <div className={classes.root}>
      <IconButton size='medium' className={classes.userIcon} onClick={handleClick}>
        <AccountCircle />
      </IconButton>
      <Menu
        id='simple-menu'
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        keepMounted
        open={Boolean(anchorEl)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'center', horizontal: 'center' }}
        onClose={handleClose}
        variant='selectedMenu'
      >
        <MenuItem>
          <Person /> {username}
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout}>
          <ExitToApp /> <FormattedMessage id='common.logout' />
        </MenuItem>
      </Menu>
    </div>
  )
}

UserInfo.defaultProps = defaultProps

export default UserInfo
